import styled from 'styled-components';

export const ResponsiveSectionContainer = styled.div<{ isMobile: boolean }>`
  padding: 0px ${({ isMobile }) => (isMobile ? '0%' : '5%')};
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: center;
  width: 100%;
`;
